import { Col, Container, Row } from 'react-bootstrap'
import React from 'react'

interface MeetingSummaryAgentLoaderProps {
  loadingText?: string
}
const DEFAULT_LOADING_TEXT = 'Loading…'

export const MeetingSummaryAgentLoader: React.FC<MeetingSummaryAgentLoaderProps> = ({ loadingText = DEFAULT_LOADING_TEXT }) => {
  return (
    <Container className='w-100 mw-100 d-flex pt-2 zocks-pb-2 flex-column gap-4 meeting-summary-agent-loader-container'>
      <Row className='h-100 g-3'>
        <Col>
          <div className='h-100 skeleton zocks-border-1.0 d-flex flex-column align-items-center justify-content-center'>
            <div className='zocks-loading-dot-dot-dot' />
            <div className='paragraph-medium'>{loadingText}</div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
